/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner } from './FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner';
import {
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSON,
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSONTyped,
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerToJSON,
} from './FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner';

/**
 * 
 * @export
 * @interface FindAllExecutionsAvailableByFacilityId200ResponseDataInner
 */
export interface FindAllExecutionsAvailableByFacilityId200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInner
     */
    facility_id: string;
    /**
     * 
     * @type {number}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInner
     */
    executions_available: number;
    /**
     * 
     * @type {string}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInner
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInner
     */
    updatedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInner
     */
    reset_enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInner
     */
    last_reset_at: string;
    /**
     * 
     * @type {number}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInner
     */
    periodic_executions_limit: number;
    /**
     * 
     * @type {Array<FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner>}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInner
     */
    executions_history?: Array<FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner>;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInner
     */
    no_analysis_facility: boolean;
}

/**
 * Check if a given object implements the FindAllExecutionsAvailableByFacilityId200ResponseDataInner interface.
 */
export function instanceOfFindAllExecutionsAvailableByFacilityId200ResponseDataInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "executions_available" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "reset_enabled" in value;
    isInstance = isInstance && "last_reset_at" in value;
    isInstance = isInstance && "periodic_executions_limit" in value;
    isInstance = isInstance && "no_analysis_facility" in value;

    return isInstance;
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSON(json: any): FindAllExecutionsAvailableByFacilityId200ResponseDataInner {
    return FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSONTyped(json, false);
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllExecutionsAvailableByFacilityId200ResponseDataInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'executions_available': json['executions_available'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'reset_enabled': json['reset_enabled'],
        'last_reset_at': json['last_reset_at'],
        'periodic_executions_limit': json['periodic_executions_limit'],
        'executions_history': !exists(json, 'executions_history') ? undefined : ((json['executions_history'] as Array<any>).map(FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSON)),
        'no_analysis_facility': json['no_analysis_facility'],
    };
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerToJSON(value?: FindAllExecutionsAvailableByFacilityId200ResponseDataInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'executions_available': value.executions_available,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'reset_enabled': value.reset_enabled,
        'last_reset_at': value.last_reset_at,
        'periodic_executions_limit': value.periodic_executions_limit,
        'executions_history': value.executions_history === undefined ? undefined : ((value.executions_history as Array<any>).map(FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerToJSON)),
        'no_analysis_facility': value.no_analysis_facility,
    };
}

